export default "__VITE_ASSET__81f6b2fb__"